<template>
  <div class="input">
    <label v-if="label" :for="name">{{ label }}</label>
    <div class="static" v-if="type === 'static'">{{ modelValue }}</div>
    <input
      v-else
      :value="modelValue"
      @change="onChange"
      :id="name"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "name",
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  methods: {
    onChange(e) {
      this.$emit("update:modelValue", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
  display: flex;
  align-items: center;

  gap: 10px;
  label {
    flex-shrink: 0;
    font-size: 13px;
  }
  .static,
  input {
    width: 100%;
    height: 30px;
    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px rgb(242, 242, 242) inset !important;
    }
  }
  input {
    background: none;
    outline: none;
    border: none;
  }
}
</style>
